export const LOADING = "LOADING";
export const PROFILE = "PROFILE";
export const PROFILE_RESPONSE = "PROFILE_RESPONSE";
export const DELETE_ACCOUNT_RESPONSE = "DELETE_ACCOUNT_RESPONSE";
